export const SIGNATURE_ASSET_PATH = 'assets/logos/mma-signature.png';
export const PRINT_IMAGES_TIMEOUT_MS = 3000;

export const MODULE_MIN_DURATION_HOURS = 1;
export const CREDITED_SESSION_TARGET_MINUTES = 180;
export const CREDITED_DAY_MAX_MINUTES = 420;
export const CREDITED_DAY_MIN_MINUTES = 30;
export const CREDITED_SPREAD_VARIATION = 0.35;
export const CREDITED_OFF_DAY_PROBABILITY = 0.45;
export const CREDITED_MORNING_START_HOUR = 8;
export const CREDITED_EVENING_START_HOUR = 18;
export const CREDITED_START_HOUR_SPAN = 3;
export const CREDITED_WIDE_START_HOUR = 9;
export const CREDITED_WIDE_START_SPAN = 10;
export const CREDITED_END_OF_DAY_MARGIN_MINUTES = 30;
